import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';
import NextLink from 'next/link';
import LazyLoad from 'react-lazyload';
import CustomButton from 'components/CustomButton';
import { useStyles } from './styles';

const Props = {
  textTitle: PropTypes.node.isRequired,
  textInformation: PropTypes.string.isRequired,
  textButton: PropTypes.string.isRequired,
};

export default function InstitutionsCommunicationMobile({
  textTitle,
  textInformation,
  textButton,
}) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box py={2}>
        <Container>
          <Typography className={classes.title} component="h2">
            <b>{textTitle}</b>
          </Typography>
          <Box display="flex" alignItems="flex-start" justifyContent="center">
            <Box mt={2}>
              <Image
                src="/images/institutions/leishmania-institutions-mobile.webp"
                alt="leishmania institutions mobile"
                loading="lazy"
                width={164}
                height={150}
              />
            </Box>

            <Box pt={2} pb={3} pl={2} maxWidth={175}>
              <Typography className={classes.textInformation} component="p">
                {textInformation}
              </Typography>
            </Box>
          </Box>

          <Box textAlign="center">
            <NextLink href={`/institutions/book-a-demo`} passHref={true}>
              <CustomButton>{textButton}</CustomButton>
            </NextLink>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}

InstitutionsCommunicationMobile.propTypes = Props;
